import {react2panel} from 'common/util/react2panel';

import {InputReact} from './';

export const InputEl = react2panel(`mp-input`, InputReact, {syncMount: true, syncUpdate: true});
